// Priebeh úlohy v Histórii spracovania — fáza, percentá, poradie vo fronte.
// Údaje posiela backend zo stavu enginu (progress, progress_message,
// queue_position). Doplnené 23. 9. 2026: klient 22. 9. videl pri 24 súboroch
// len „V rade“ bez poradia a bez priebehu, niektoré čakali vyše 3 minúty.
import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const dokumentov = (n) => (n === 1 ? 'dokument' : n >= 2 && n <= 4 ? 'dokumenty' : 'dokumentov');

// Engine posiela technické hlášky; fázu určujeme z priebehu (0–1), ktorý engine
// rozdeľuje: 0–0,05 príprava, 0,05–0,70 OCR a detekcia, 0,70–0,75 vyhodnotenie,
// 0,75–0,95 začiernenie po stranách, potom dokončenie.
export const phaseLabel = (progress, message) => {
  const p = Number(progress) || 0;
  if (p < 0.05) return 'Pripravujem dokument';
  if (p < 0.70) return 'Rozpoznávam text a hľadám osobné údaje';
  if (p < 0.75) return 'Vyhodnocujem nájdené údaje';
  if (p < 0.95) {
    const m = /strany\s+(\d+)\s*\/\s*(\d+)/i.exec(message || '');
    return m ? `Začierňujem – strana ${m[1]} z ${m[2]}` : 'Začierňujem';
  }
  return 'Dokončujem';
};

export const queueLabel = (position) => {
  const n = Number(position) || 0;
  return n > 0 ? `Čaká vo fronte – pred vami ${n} ${dokumentov(n)}` : 'Čaká vo fronte';
};

const JobProgress = ({ job }) => {
  const engine = job.engine_status || job.status;
  if (engine === 'pending' || (job.status === 'pending' && engine !== 'running')) {
    return (
      <Box sx={{ mt: 1, minWidth: 180 }}>
        <LinearProgress color="warning" sx={{ height: 5, borderRadius: 3 }} />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {queueLabel(job.queue_position)}
        </Typography>
      </Box>
    );
  }
  if (engine === 'running' || job.status === 'running') {
    const pct = Math.max(1, Math.min(99, Math.round((Number(job.progress) || 0) * 100)));
    return (
      <Box sx={{ mt: 1, minWidth: 180 }}>
        <LinearProgress variant="determinate" value={pct} sx={{ height: 5, borderRadius: 3 }} />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {phaseLabel(job.progress, job.progress_message)} · {pct} %
        </Typography>
      </Box>
    );
  }
  return null;
};

export default JobProgress;
